module.exports = __webpack_public_path__ + "media/images/menu/cancer-764fbd40d85e7fb6fc92b81d40021366.jpg";